export default __webpack_public_path__ + "assets/images/v-icon2-928a3fd5.svg";